import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import FormContent from 'components/organisms/formContent';
import FormCol from 'components/molecules/formCol';
import FormHr from 'components/atoms/formHr';
import FormTextField from 'components/molecules/formTextField/index.jsx';
import ArrowLink from 'components/atoms/arrowLink';
import { currency } from 'helpers/format';
import * as planHelper from 'helpers/maintenancePlan';
import LinkingPos from './LinkinPos';

class Payment extends Component {
  render() {
    const { maintenancePlan, code } = this.props;

    return (
      <div className="review">
        <Header />

        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Contrato de mantenimiento</h2>

              <FormContent small>
                  <FormCol single center>
                    <div className="shiftInfo">
                      <p>Tu turno fue generado exitosamente.</p>
                      <FormTextField
                        label="Código del turno"
                        type="text"
                        inline
                        size="s"
                        value={code}
                        center
                        readonly
                      />
                      <p>
                        En unos minutos recibirás un email con los datos. Si necesitás cambiar el
                        horario o cancelar el turno podés llamarnos al: <br /> 0261 4439300.
                      </p>
                      <FormHr />
                      <h4>Pagá tu contrato de mantenimiento online</h4>
                      <p>
                        Ahora podés proceder al pago del <strong>contrato de mantenimiento</strong>{' '}
                        que seleccionaste, y así disfrutar al beneficio de{' '}
                        {maintenancePlan.services.length} servicios por solo{' '}
                        {currency(planHelper.getPrice(maintenancePlan))}
                        {maintenancePlan.installments &&
                          ` en hasta ${maintenancePlan.installments} cuotas sin interés`}
                        {'. '}
                        {maintenancePlan.online_pay_discount && (
                          <strong>
                            {' '}
                            con {maintenancePlan.online_pay_discount}% de descuento por pago
                            online.`
                          </strong>
                        )}
                      </p>
                      
                      <LinkingPos amount={planHelper.getPriceWithOnlineDiscount(maintenancePlan)} code={code} />
                    </div>
                  </FormCol>
              </FormContent>
              <div className="noprint">
                <p className="s">
                  <ArrowLink size="small" style="blue" href="http://www.territorioyacopini.com.ar">
                    Volver a Territorio Yacopini
                  </ArrowLink>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const selector = formValueSelector('shiftRequest');

Payment = reduxForm({
  form: 'paymentForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Payment);

const mapStateToProps = state => {
  return {
    maintenancePlan: state.maintenancePlans.available,
    code: state.shifts.code,
    personal_information: selector(state, 'personal_information'),
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
